// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguageContext } from "../context/languageContext";
import { Footer } from "../components/Footer";

const TermsOfService = () => {
    const navigate = useNavigate();
    const { t } = useLanguageContext();

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50/30">
            {/* Decorative Background */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
                <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gradient-to-bl from-indigo-100/40 to-transparent rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gradient-to-tr from-purple-100/30 to-transparent rounded-full blur-3xl"></div>
            </div>

            <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
                {/* Back Button */}
                <button
                    onClick={() => navigate(-1)}
                    className="group inline-flex items-center gap-2 px-4 py-2.5 bg-white/80 backdrop-blur-sm text-indigo-600 font-medium rounded-xl hover:bg-indigo-50 border border-indigo-100/50 shadow-sm mb-8 transition-all"
                >
                    <svg className="h-4 w-4 group-hover:-translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    {t("Back")}
                </button>

                {/* Main Content Card */}
                <div className="bg-white rounded-3xl shadow-xl border border-slate-100 overflow-hidden">
                    {/* Header */}
                    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-8 py-12 text-center">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl mb-4">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </div>
                        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">{t("Terms of Service")}</h1>
                        <p className="text-indigo-100 text-sm">Last Updated: February 10, 2026</p>
                    </div>

                    {/* Content */}
                    <div className="px-6 sm:px-8 py-8 space-y-8">
                        {/* Introduction */}
                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2">
                                <span className="w-1.5 h-8 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full"></span>
                                {t("Introduction")}
                            </h2>
                            <p className="text-slate-600 leading-relaxed">
                                Welcome to Vivas Guest Experience. By accessing and using our digital ordering and room service platform, you agree to be bound by these Terms of Service. Please read them carefully before using our services.
                            </p>
                        </section>

                        {/* Acceptance of Terms */}
                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2">
                                <span className="w-1.5 h-8 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full"></span>
                                {t("Acceptance of Terms")}
                            </h2>
                            <p className="text-slate-600 leading-relaxed mb-3">
                                By accessing our platform, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions. If you do not agree with any part of these terms, you must not use our services.
                            </p>
                            <p className="text-slate-600 leading-relaxed">
                                We reserve the right to modify these terms at any time. Continued use of the platform after changes constitutes acceptance of the modified terms.
                            </p>
                        </section>

                        {/* Use of Service */}
                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2">
                                <span className="w-1.5 h-8 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full"></span>
                                {t("Use of Service")}
                            </h2>
                            <div className="space-y-3">
                                <div className="flex gap-3">
                                    <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center text-sm font-bold">1</span>
                                    <p className="text-slate-600 leading-relaxed">You must be at least 18 years old or have parental consent to use our services.</p>
                                </div>
                                <div className="flex gap-3">
                                    <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center text-sm font-bold">2</span>
                                    <p className="text-slate-600 leading-relaxed">You are responsible for maintaining the confidentiality of your account information.</p>
                                </div>
                                <div className="flex gap-3">
                                    <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center text-sm font-bold">3</span>
                                    <p className="text-slate-600 leading-relaxed">You agree to use the service only for lawful purposes and in accordance with these terms.</p>
                                </div>
                                <div className="flex gap-3">
                                    <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center text-sm font-bold">4</span>
                                    <p className="text-slate-600 leading-relaxed">You must not attempt to interfere with, compromise, or disrupt the service or its security.</p>
                                </div>
                            </div>
                        </section>

                        {/* Orders and Payments */}
                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2">
                                <span className="w-1.5 h-8 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full"></span>
                                {t("Orders and Payments")}
                            </h2>
                            <p className="text-slate-600 leading-relaxed mb-3">
                                All orders placed through our platform are subject to acceptance and availability. We reserve the right to refuse or cancel any order for any reason, including but not limited to product availability, errors in pricing or product information, or suspected fraudulent activity.
                            </p>
                            <p className="text-slate-600 leading-relaxed">
                                Prices are displayed in the local currency and include applicable taxes unless otherwise stated. Payment is due at the time of service delivery. We accept various payment methods as indicated on the platform.
                            </p>
                        </section>

                        {/* Cancellations and Refunds */}
                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2">
                                <span className="w-1.5 h-8 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full"></span>
                                {t("Cancellations and Refunds")}
                            </h2>
                            <p className="text-slate-600 leading-relaxed mb-3">
                                Orders may be cancelled before preparation begins. Once preparation has started, cancellations may not be possible. Please contact our staff immediately if you need to modify or cancel an order.
                            </p>
                            <p className="text-slate-600 leading-relaxed">
                                Refunds will be processed in accordance with our refund policy and may take 5-10 business days to appear in your account, depending on your payment method.
                            </p>
                        </section>

                        {/* Limitation of Liability */}
                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-2">
                                <span className="w-1.5 h-8 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full"></span>
                                {t("Limitation of Liability")}
                            </h2>
                            <p className="text-slate-600 leading-relaxed">
                                To the maximum extent permitted by law, Vivas Guest Experience shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our services.
                            </p>
                        </section>

                        {/* Contact Information */}
                        <section className="bg-gradient-to-br from-indigo-50/50 to-purple-50/30 rounded-2xl p-6 border border-indigo-100/50">
                            <h2 className="text-xl font-bold text-slate-900 mb-3">{t("Contact Us")}</h2>
                            <p className="text-slate-600 leading-relaxed mb-4">
                                If you have any questions about these Terms of Service, please contact us:
                            </p>
                            <div className="space-y-2 text-sm">
                                <p className="text-slate-700"><span className="font-semibold">Email:</span> support@vivasexperience.com</p>
                                <p className="text-slate-700"><span className="font-semibold">Phone:</span> +355 69 521 7675</p>
                                <p className="text-slate-700"><span className="font-semibold">Address:</span> Vivas Hotel, Tirana, Albania</p>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default TermsOfService;
